/* src/@fuse/components/countdown/countdown.component.scss */
fuse-countdown {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
fuse-countdown .fuse-countdown {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
}
fuse-countdown .fuse-countdown .time {
  display: flex;
  flex-direction: column;
  padding: 0 12px;
}
fuse-countdown .fuse-countdown .time .value {
  font-size: 34px;
  line-height: 34px;
  padding-bottom: 8px;
}
fuse-countdown .fuse-countdown .time .title {
  color: rgba(0, 0, 0, 0.54);
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL0BmdXNlL2NvbXBvbmVudHMvY291bnRkb3duL2NvdW50ZG93bi5jb21wb25lbnQuc2NzcyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiZnVzZS1jb3VudGRvd24ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuXG4gICAgLmZ1c2UtY291bnRkb3duIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcblxuICAgICAgICAudGltZSB7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgICAgIHBhZGRpbmc6IDAgMTJweDtcblxuICAgICAgICAgICAgLnZhbHVlIHtcbiAgICAgICAgICAgICAgICBmb250LXNpemU6IDM0cHg7XG4gICAgICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDM0cHg7XG4gICAgICAgICAgICAgICAgcGFkZGluZy1ib3R0b206IDhweDtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgLnRpdGxlIHtcbiAgICAgICAgICAgICAgICBjb2xvcjogcmdiYSgwLCAwLCAwLCAwLjU0KTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgIH1cbn1cbiJdLAogICJtYXBwaW5ncyI6ICI7QUFBQTtBQUNJLFdBQUE7QUFDQSxrQkFBQTtBQUNBLGVBQUE7QUFDQSxtQkFBQTs7QUFFQSxlQUFBLENBQUE7QUFDSSxXQUFBO0FBQ0Esa0JBQUE7QUFDQSxlQUFBO0FBQ0EsbUJBQUE7QUFDQSxjQUFBOztBQUVBLGVBQUEsQ0FQSixlQU9JLENBQUE7QUFDSSxXQUFBO0FBQ0Esa0JBQUE7QUFDQSxXQUFBLEVBQUE7O0FBRUEsZUFBQSxDQVpSLGVBWVEsQ0FMSixLQUtJLENBQUE7QUFDSSxhQUFBO0FBQ0EsZUFBQTtBQUNBLGtCQUFBOztBQUdKLGVBQUEsQ0FsQlIsZUFrQlEsQ0FYSixLQVdJLENBQUE7QUFDSSxTQUFBLEtBQUEsQ0FBQSxFQUFBLENBQUEsRUFBQSxDQUFBLEVBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
